var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "content_box_div" }, [
    _c("div", { staticClass: "container-head container-header" }, [
      _c("div", { staticClass: "head-info" }, [
        _vm.showAlertsChart
          ? _c("span", [_vm._v("Alerts Per Day")])
          : _c("span", [_vm._v("Number of Requests Per Day")]),
        _vm._v(" "),
        _vm.isalertchart
          ? _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.changeChart(_vm.showAlertsChart)
                  }
                }
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                    swap_vertical_circle\n                "
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-details" }, [
      _c("div", { staticClass: "chart-content" }, [
        _c("canvas", {
          attrs: { id: "alertsChart", width: "550", height: "150" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }